import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import Dropdown, { DROPDOWN_POSITION_CENTER } from 'components/Shared/Dropdown/Index'
import AvatarImage from 'assets/img/avatar.svg'
import colors from 'components/utils/colors'

const StyledDropdown = styled(Dropdown)`
  display: inline-block;
`

const StyledProfileAvatar = styled.img`
  min-width: ${props => props.minWidth || 'initial'};
  min-height: ${props => props.minHeight || 'initial'};
  max-height: ${props => props.maxHeight || '120px'};
  max-width: ${props => props.maxWidth || '120px'};
  background-size: 100%;
  ${props => props.withBorder && css`border: 1px solid ${colors.secondary80};`}
`

const ImageWrapper = styled.div`
  display: flex;
`

const ImageLabelOverlay = styled.div`
  position: absolute;
  display: flex;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  align-items: flex-end;
  justify-content: center;
  clip-path: circle(50% at center);
  cursor: pointer;

  &:hover div {
    background: #${colors.secondary20};
    transition: background 0.5s;
  }

`

const ImageLabel = styled.div`
  font-weight: 600;
  font-size: 10px;
  color: #FFFFFF;
  background: rgba(51, 51, 51, 0.5);
  width: 100%;
  height: 30px;
  user-select: none;
  text-align: center;
  padding-top: 7px;
  box-sizing: border-box;
`

const ImageWithMenu = ({ children, img, minWidth, maxWidth, minHeight, maxHeight, className, bottomLabel, withBorder }) => {
  return (
    <StyledDropdown
      activateOnClick
      position={DROPDOWN_POSITION_CENTER}
      activatorComponent={
        <ImageWrapper>
          <StyledProfileAvatar
            className={className}
            src={img || AvatarImage}
            minWidth={minWidth}
            maxWidth={maxWidth}
            minHeight={minHeight}
            maxHeight={maxHeight}
            withBorder={withBorder}
          />
          {bottomLabel && (
            <ImageLabelOverlay>
              <ImageLabel>{bottomLabel}</ImageLabel>
            </ImageLabelOverlay>
          )}
        </ImageWrapper>
      }
    >
      {children}
    </StyledDropdown>
  )
}

ImageWithMenu.propTypes = {
  children: PropTypes.node,
  img: PropTypes.string,
  minWidth: PropTypes.string,
  maxWidth: PropTypes.string,
  minHeight: PropTypes.string,
  maxHeight: PropTypes.string,
  className: PropTypes.string,
  bottomLabel: PropTypes.string,
  withBorder: PropTypes.bool,
}

export default ImageWithMenu
